// Portfolio copy is kept separate from presentation so it can evolve with Charan's work.
// Project descriptions are based on the existing portfolio and embedded résumé.
export const profile = {
  name: "Charan Sri Teja Burra",
  email: "charansriteja.burra@gmail.com",
  github: "https://github.com/itscharanteja",
  linkedin: "https://www.linkedin.com/in/charan-sri-teja-burra-a386a5225",
  location: "Sweden",
};

export const projects = [
  {
    id: "pose",
    number: "01",
    category: "Applied AI",
    context: "Bachelor thesis · Computer vision",
    title: "What if a camera could be a biomechanics lab?",
    name: "2D → 3D Pose Estimation",
    description:
      "Turning cycling footage into 3D movement data, with a practical interface for coaches.",
    problem:
      "Make video-based movement analysis more accessible, using ordinary cycling footage as the starting point.",
    approach:
      "Connect AlphaPose for 2D joint detection with MotionBERT for 3D pose estimation, then make the analysis accessible through a Streamlit application.",
    discussion:
      "The interesting boundary is between a model's output and something a coach can interpret: joint kinematics, visualisation, and the limitations of video-based estimation.",
    stack: ["Python", "AlphaPose", "MotionBERT", "Streamlit"],
    href: "https://github.com/itscharanteja/Human_Pose_Estimation_Streamlit",
    artifact: "Explore the thesis project",
  },
  {
    id: "ticket",
    number: "02",
    category: "Applied AI",
    context: "AI engineering · Internal tools",
    title: "Give a support question the context it needs.",
    name: "AI Ticketing Assistant",
    description:
      "A helpdesk workflow that connects ticket classification, retrieval, and resolution support.",
    problem:
      "Connect incoming support requests with relevant knowledge and automate the repetitive steps around resolving a ticket.",
    approach:
      "Bring LLM-based classification and RAG workflows together with orchestration, notifications, and CI/CD integration.",
    discussion:
      "Retrieval and workflow design matter as much as the model. This project is a useful starting point for a conversation about grounding responses and integrating AI with existing operations.",
    stack: ["LLM integration", "RAG", "PostgreSQL", "CI/CD"],
    href: "https://github.com/itscharanteja/AI_Ticketing_assistant",
    artifact: "Explore the assistant",
  },
  {
    id: "content",
    number: "03",
    category: "Full-stack",
    context: "Product engineering · AI automation",
    title: "Make content generation part of a working product.",
    name: "AI Content Engine",
    description:
      "An end-to-end SaaS platform connecting AI content generation with the workflow around it.",
    problem:
      "Move AI-generated content into an application that supports an end-to-end workflow, from the interface through to the backend.",
    approach:
      "Build the product with React and TypeScript, connect Node.js and Express services, and deploy the application on Google Cloud.",
    discussion:
      "The work spans the boundaries between interface, backend services, and deployment. It shows the kind of full-stack ownership I want to keep developing.",
    stack: ["React", "TypeScript", "Node.js", "Express", "GCP"],
    href: "https://github.com/itscharanteja/AI_Content_Engeine_SaaS",
    artifact: "Explore the content engine",
  },
  {
    id: "portal",
    number: "04",
    category: "Full-stack",
    context: "Web engineering · Microservices",
    title: "Different roles. One coherent experience.",
    name: "Full-Stack Job Portal",
    description:
      "A job platform bringing role-based access, search, and cloud storage into one application.",
    problem:
      "Support a job portal's different users with appropriate permissions, responsive filtering, and reliable document storage.",
    approach:
      "Combine ASP.NET Core microservices, JWT authentication, and role-based access control with Azure Blob Storage and a React interface.",
    discussion:
      "This is a project about the less visible parts of a good interface: service boundaries, authentication, permissions, and the data behind the interaction.",
    stack: ["ASP.NET Core", "React", "Azure", "JWT", "Docker"],
    href: "https://github.com/itscharanteja/JobPortal_ASP.NET",
    artifact: "Explore the job portal",
  },
];

export const experience = [
  {
    period: "Nov 2025 — Jan 2026",
    company: "Runix Software AB",
    role: "AI & Full-Stack Developer",
    place: "Sweden",
    detail:
      "AI automation, Make.com workflows, scalable web applications, and integrations shaped around clients' needs.",
  },
  {
    period: "Mar — Aug 2024",
    company: "Outlier AI",
    role: "Generative AI Engineer · Freelance",
    place: "Remote",
    detail:
      "Prompt engineering, code-generation optimisation, backend AI pipelines, and LLM integrations.",
  },
  {
    period: "May — Jul 2024",
    company: "Main Flow Services & Technologies",
    role: "Full-Stack Web Developer Intern",
    place: "Remote",
    detail:
      "React modularisation, API integration, and CI/CD improvements. Work that contributed to a 40% reduction in frontend errors.",
  },
  {
    period: "May — Jul 2023",
    company: "AICTE",
    role: "Cloud Computing Intern",
    place: "Remote",
    detail:
      "AWS architecture, S3, CloudFront, Route 53, and authentication workflows.",
  },
];

export const capabilities = [
  {
    title: "Interfaces people can use",
    tools: "React · TypeScript · Next.js · Tailwind",
    detail: "Connecting a complex system to a clear interaction.",
  },
  {
    title: "The systems underneath",
    tools: "Node.js · Python · ASP.NET Core · PostgreSQL",
    detail: "APIs, data, permissions, and the connections between them.",
  },
  {
    title: "AI with a job to do",
    tools: "LLM APIs · RAG · Vector search · Automation",
    detail: "Bringing models into useful, repeatable workflows.",
  },
  {
    title: "From local to live",
    tools: "AWS · Azure · GCP · Docker · CI/CD",
    detail: "Taking responsibility for how the whole thing runs.",
  },
];
